import { useState } from 'react'
import {
  DateTimePicker,
  DateTimePickerProps,
  LocalizationProvider,
} from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

import { TextField, TextFieldProps } from '@mui/material'
import { colors } from '@/theme/colors.theme'
import { dateTimeFormat } from '@/constants/date'

interface Props extends DateTimePickerProps<Date> {
  margin?: 'dense' | 'normal' | 'none'
}

export const DateTimePickerComponent = ({
  slots,
  slotProps,
  margin,
  onOpen,
  onClose,
  ...props
}: Props) => {
  const [position, setPosition] = useState(null)

  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
    onOpen && onOpen()
  }

  const handleClose = () => {
    setOpen(false)
    onClose && onClose()
  }
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setPosition(event.currentTarget?.getBoundingClientRect())
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        ampm={false}
        format={dateTimeFormat}
        slots={{
          textField: (params: TextFieldProps) => <TextField {...params} />,
          ...slots,
        }}
        slotProps={{
          textField: {
            margin: margin || 'normal',
            style: { width: '190px' },
            onKeyDown: (e) => {
              e.preventDefault()
            },
            onClick: (e) => {
              handleClick(e)
              handleOpen()
            },
          },
          popper: {
            sx: {
              top: `${position?.top + 40}px !important`,
              left: `${position?.left}px !important`,
              transform: 'none !important',
            },
          },
          openPickerIcon: {
            sx: { color: colors.white },
          },
          layout: {
            className: 'MuiDateCalendar-custom',
          },
          ...slotProps,
        }}
        {...props}
      />
    </LocalizationProvider>
  )
}
